import { render, staticRenderFns } from "./Summary_2.vue?vue&type=template&id=f36b1d6e&scoped=true"
import script from "./Summary_2.vue?vue&type=script&lang=js"
export * from "./Summary_2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f36b1d6e",
  null
  
)

export default component.exports